var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdStyles } from "../../../less/IdStyles";
import { BaseButton } from "../base-button/BaseButton";
import { IdButtonType } from "../base-button/IdButtonType";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
export var HudQuestPagerButtonDown = React.memo(function (props) { return (React.createElement(BaseButton, __assign({ name: IdStyles.ButtonPrimary, styleId: IdButtonType.ButtonRectangleExtraSmall }, props),
    React.createElement("div", { className: "flex flex--guts" },
        React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconSmall, orientation: IdOrientation.Down })))); });



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/HudQuestPagerButtonDown.tsx
// module id = 2282
// module chunks = 3